import { connect } from 'react-redux';
import LaporanAbsensiPegawai from '../../../views/Personnel/Absensi/LaporanAbsensiPegawai.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(LaporanAbsensiPegawai);